import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/services/alert.service';
import { AlertMode, AlertType } from '../types/type';

@Component({
  selector: 'app-custom-alert',
  templateUrl: './custom-alert.component.html',
  styleUrls: ['./custom-alert.component.scss']
})
export class CustomAlertComponent implements OnInit {

  DXCToasterCssClass: string = 'hideAlert';
  DXCToasterType: AlertType = 'error';
  DXCToasterMode: AlertMode = 'inline';
  DXCToasterInlineText: string = '';
  alertSubcription: Subscription;

  constructor(
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.alertService.errorToastObservable.subscribe( res => {
      this.showDXCToaster(res)
    })
  }

  // ngOnDestroy(): void {
  //   if (this.alertSubcription) {
  //     this.alertSubcription.unsubscribe();
  //   }
  // }

  showDXCToaster(errorMessage: string) {
    this.DXCToasterInlineText = errorMessage;
    this.DXCToasterCssClass = "showAlert";
    setTimeout(() => {
      this.DXCToasterCssClass = "hideAlert";
    }, 5000);
  }

}
